import React from 'react'

import { useCollection, useCurrentCollectionId } from 'hooks/menu-collections'

import { getOldCollectionMerchandisingHeader } from '../../../MenuExperience/CollectionScreen/getOldCollectionMerchandisingHeader'
import { useShouldRemoveMerchandisingBanner } from '../useShouldRemoveMerchandisingBanner'
import { MerchandisingHeader } from './MerchandisingHeader'

const CollectionHeaderWrapper = () => {
  const currentCollectionId = useCurrentCollectionId()
  const collection = useCollection(currentCollectionId)
  const merchandisingHeader = getOldCollectionMerchandisingHeader(collection?.merchandising)
  const removeMerchandisingBanner = useShouldRemoveMerchandisingBanner()

  if (!merchandisingHeader || removeMerchandisingBanner) {
    return null
  }

  return <MerchandisingHeader header={merchandisingHeader} />
}

export { CollectionHeaderWrapper }
